<template>
    <div name="barocare-story" class="barocare-story" id="barocare-story">
        <div class="container">
            <div class="section-header">
                <strong class="title">바로돌봄 제휴 신청</strong>
                <p class="sub-text">주야간보호센터, 요양원, 정신병원 등 바로돌봄 도입이 필요한 곳을 기다립니다.<br>
                솔닥과 함께 더 나은 세상을 만드는 일에 동참하세요.</p>
                <button type="button" class="btn btn-inquiry" @click="goInquiry">제휴 문의하기</button>
                <button type="button" class="btn btn-request" @click="goRequest">제휴 신청하기</button>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
    name: 'barocare-story',
    components: {
        Carousel,
        Slide,
    },
    data() {
        return {
        };
    },
    methods: {
        goInquiry: function()
        {
            window.open('https://forms.gle/yyZ2sE1VbEEbzKwL8', '_blank')
        },
        goRequest: function()
        {
            window.open('https://partner.soldoc.co.kr/home?type=b2b', '_blank')
        },
    },
}
</script>

<style scoped>
    .barocare-story{
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        
    }

    /* .barocare-story::after{
        position:absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -49.5%);
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        background: url(../../assets/pc_barocare/bg_barocare-story.png) no-repeat;
        background-size: 100% auto;
        background-position: center center;
        object-fit: contain;
    } */
    .barocare-story .container{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        min-width: 960px;
        width: 100%;
        /* max-width: 1320px; */
        height: 494px;
        margin: 0 auto;
        padding: 116px 20px 129px;
        z-index: 1;
    }

    .barocare-story .container{
        max-width: 100%;
        height: 100%;
        background: url(../../assets/pc_barocare/bg_barocare-story.png) no-repeat;
        background-position: center;
        background-size: cover;
    }
    .section-header{
        width: 100%;
        max-width: 1320px
    }
    .section-header .title{
        font-family: 'Pretendard';
        font-style: normal;
        font-size: 44px;
        font-weight: 600;
        line-height: 1.6;
        color: #fff;
    }
    .sub-text{
        margin-top: 15px;
        margin-bottom: 50px;
        font-size: 18px;
        font-family: 'Pretendard';
        font-weight: 400;
        line-height: 1.6;
        color: #fff;
    }
    .btn{
        display: inline-flex;
        padding: 10px 24px;
        align-items: flex-start;
        border-radius: 4px;
        border: 1px solid #fff;
        font-family: 'Pretendard';
        font-size: 18px;
        font-weight: 600;
        line-height: 30px; 
    }
    .btn+.btn{
        margin-left: 2px;
    }
    .btn-inquiry{
        background: #fff;
        color: #0082EC;
    }
    .btn-inquiry:hover{
        border: 1px solid #0082EC;
        background: #0082EC;
        color: #fff;
    }
    .btn-request{
        color: #fff;
    }
    .btn-request:hover{
        background: #fff;
        color: #0082EC;
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_barocare/BarocareStory.vue